import { Box, Grid, Typography, useTheme } from '@mui/material';
import parse from 'html-react-parser';
import React from 'react';
import StyledPortfolio from './styles';
// Import css files
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

//icon solution
import IconSolution1 from '../../../components/Icons/IconSolution/IconSolution1';
import IconSolution2 from '../../../components/Icons/IconSolution/IconSolution2';
import IconSolution3 from '../../../components/Icons/IconSolution/IconSolution3';
import IconSolution4 from '../../../components/Icons/IconSolution/IconSolution4';
import IconSolution5 from '../../../components/Icons/IconSolution/IconSolution5';
import IconSolution6 from '../../../components/Icons/IconSolution/IconSolution6';
import IconSolution7 from '../../../components/Icons/IconSolution/IconSolution7';
import IconSolution8 from '../../../components/Icons/IconSolution/IconSolution8';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
const CARDS = 10;
const MAX_VISIBILITY = 3;

const CardCarousel = ({ title, content }) => (
  <div className="card">
    <h2>{title}</h2>
    <p>{content}</p>
  </div>
);

// const Carousel = ({ children }) => {
//   const [active, setActive] = useState(2);
//   const count = React.Children.count(children);

//   return (
//     <div className="carousel">
//       {active > 0 && (
//         <button className="nav left" onClick={() => setActive((i) => i - 1)}>
//           <ArrowBackIosIcon />
//         </button>
//       )}
//       {React.Children.map(children, (child, i) => (
//         <div
//           className="card-container"
//           style={{
//             '--active': i === active ? 1 : 0,
//             '--offset': (active - i) / 3,
//             '--direction': Math.sign(active - i),
//             // '--abs-offset': Math.abs(active - i) / 3,
//             'pointer-events': active === i ? 'auto' : 'none',
//             opacity: Math.abs(active - i) >= MAX_VISIBILITY ? '0' : '1',
//             'z-index': i === active ? '-1' : '999',
//             display: Math.abs(active - i) > MAX_VISIBILITY ? 'none' : 'block',
//           }}
//         >
//           {child}
//         </div>
//       ))}
//       {active < count - 1 && (
//         <button className="nav right" onClick={() => setActive((i) => i + 1)}>
//           <ArrowForwardIosIcon />
//         </button>
//       )}
//       {/* <div className="pageIndicatorContainer">
//         <div
//           className="pageIndicator"
//           style={{
//             backgroundColor: active === 0 || active === 3 || active === 6 || active === 9 ? '#00FF00' : '#000000',
//           }}
//         ></div>
//         <div
//           className="pageIndicator"
//           style={{
//             backgroundColor: active === 1 || active === 4 || active === 7 || active === 10 ? '#00FF00' : '#000000',
//           }}
//         ></div>
//         <div
//           className="pageIndicator"
//           style={{
//             backgroundColor: active === 2 || active === 5 || active === 8 ? '#00FF00' : '#000000',
//           }}
//         ></div>
//       </div> */}
//     </div>
//   );
// };

const CarouselMobile = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const label = `JADE SOFT Turnkey 솔루션이 제공하는 것은 IT 솔루션일 뿐만 아니라 운영을 지원하는 서비스입니다. <br/> JADE SOFT의 전문 팀은 빅데이터를 사용하여 비정상적인 승리에 대해 팀에 경고하고, 위험 분석에 대한 확장된 지원을 제공합니다.<br/> JADE SOFT 프리미엄 패키지에서는 전문 팀 + 전담 계정 관리자가 배정되어<br/>  프로젝트 관리, 구성 관리, 가이드 및 시스템 기능을 극대화하는 방법에 대한 제안을 도울 것입니다.`;
  const iGamingSolutions = [
    {
      id: 1,
      title: t('igamingsolu-title-one'),
      content: t('igamingsolu-content-one'),
      image: <IconSolution1 />,
    },
    {
      id: 2,
      title: t('igamingsolu-title-two'),
      content: t('igamingsolu-content-two'),
      image: <IconSolution2 />,
    },
    {
      id: 3,
      title: t('igamingsolu-title-three'),
      content: t('igamingsolu-content-three'),
      image: <IconSolution3 />,
    },
    {
      id: 4,
      title: t('igamingsolu-title-four'),
      content: t('igamingsolu-content-four'),
      image: <IconSolution4 />,
    },
    {
      id: 5,
      title: t('igamingsolu-title-five'),
      content: t('igamingsolu-content-five'),
      image: <IconSolution5 />,
    },
    {
      id: 6,
      title: t('igamingsolu-title-six'),
      content: t('igamingsolu-content-six'),
      image: <IconSolution6 />,
    },
    {
      id: 7,
      title: t('igamingsolu-title-seven'),
      content: t('igamingsolu-content-seven'),
      image: <IconSolution7 />,
    },
    {
      id: 8,
      title: t('igamingsolu-title-eight'),
      content: t('igamingsolu-content-eight'),
      image: <IconSolution8 />,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const customPrevArrow = (onClickHandler, hasPrev) => (
    <button
      type="button"
      onClick={onClickHandler}
      style={{
        position: 'absolute',
        left: '-9px',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: 'transparent',
        color: '#000',
        border: 'none',
        padding: '10px',
        cursor: hasPrev ? 'pointer' : 'not-allowed',
        opacity: hasPrev ? 1 : 0.5,
        zIndex: 999,
      }}
    >
      <ArrowBackIosIcon />
    </button>
  );

  const customNextArrow = (onClickHandler, hasNext) => (
    <button
      type="button"
      onClick={onClickHandler}
      style={{
        position: 'absolute',
        right: '-15px',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: 'transparent',
        color: '#000',
        border: 'none',
        padding: '10px',
        cursor: hasNext ? 'pointer' : 'not-allowed',
        opacity: hasNext ? 1 : 0.5,
      }}
    >
      <ArrowForwardIosIcon />
    </button>
  );

  return (
    <>
      {/* <Wave
        fill="#fff"
        paused={false}
        style={{ display: 'flex', position: 'absolute', zIndex: 999, marginTop: '-46px' }}
        options={{
          height: 20,
          amplitude: 20,
          speed: 0.15,
          points: 3,
        }}
      /> */}
      <StyledPortfolio>
        <Carousel renderArrowPrev={customPrevArrow} renderArrowNext={customNextArrow} showThumbs={false}>
          {iGamingSolutions.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={3}
              key={index}
              sx={{
                justifyItems: 'center',
              }}
            >
              {/* display={'flex'} */}
              <Box sx={{ maxWidth: '100%', maxHeight: '100%', mt: 5 }} key={item.id}>
                <Box
                  sx={{
                    backgroundColor: '#ffffff',
                    textAlign: 'center',
                    // paddingLeft: 0,
                    // paddingRight: 0,
                    // width: '628px',
                    // height: '321.56px',
                    maxWidth: '628px',
                    maxHeight: '100%',
                  }}
                >
                  <Box
                    px={12}
                    sx={{
                      [theme.breakpoints.down('lg')]: {
                        width: '115px',
                        height: '114.88px',
                        display: 'unset',
                        justifyContent: 'center',
                        textAlign: 'center',
                        justifySelf: 'center',
                        mb: 3
                      },
                    }}
                  >
                    {item.image}
                  </Box>
                  <Box
                    display={'flex'}
                    justifyContent={'center'}
                    sx={{
                      px: 8,
                      [theme.breakpoints.down('lg')]: {
                        px: 1,
                      },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 2,
                        mb: 2,
                        lineHeight: '26.67px',
                        wordWrap: 'break-word',
                        fontWeight: 800,
                        fontSize: '21.3px',
                        color: '#676767',
                        [theme.breakpoints.down('lg')]: {
                          mt: 2,
                          fontSize: '24px',
                          lineHeight: '28.64px',
                          color: '#000',
                        },
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>
                  <Box px={1}>
                    <Typography
                      variant="body1"
                      sx={{
                        // mb: 4,
                        lineHeight: '20px',
                        // wordWrap: 'break-word',
                        fontWeight: 600,
                        fontSize: '16px',
                        color: '#676767',
                        [theme.breakpoints.down('lg')]: {
                          fontSize: '16px',
                          lineHeight: '19.09px',
                          color: '#000',
                          fontWeight: 500,
                        },
                      }}
                    >
                      {parse(item.content)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Carousel>
        {/* <ArrowBackIosIcon className="control-arrow control-prev" />
        <ArrowForwardIosIcon className="control-arrow control-prev" /> */}
      </StyledPortfolio>
    </>
  );
};

export default CarouselMobile;
